import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Country } from 'components/common/CommonTypes';
import { Countries } from 'Constants/Common';

export type Features = {
    Internationalization: boolean;
    GapClaim: boolean;
    UKTyreClaim: boolean;
    BankAccount: boolean;
    WheelDamage: boolean;
    CosmeticDamage: boolean;
    ActiveClaim: boolean;
    LanguageSwitch?: boolean;
};

export type SiteState = {
    brandId: number;
    brandStyles: string;
    brandSearchComplete: boolean;
    clientId: string;
    domain: string;
    audience: string;
    features: Features;
    country: Country;
    showBankDetails?: boolean;
    showRepairAddress?: boolean;
};

export const initialState: SiteState = {
    brandId: 0,
    brandStyles: '',
    brandSearchComplete: false,
    clientId: '',
    domain: '',
    audience: '',
    features: {
        Internationalization: false,
        GapClaim: false,
        UKTyreClaim: false,
        BankAccount: false,
        WheelDamage: false,
        CosmeticDamage: false,
        ActiveClaim: false
    },
    country: Countries.Uk,
    showBankDetails: false,
    showRepairAddress: true
};

export const siteSlice = createSlice({
    name: 'site',
    initialState,
    reducers: {
        setSite: (_, action: PayloadAction<SiteState>) => action.payload,
        setBrandSearchComplete: (state, action: PayloadAction<boolean>) => {
            state.brandSearchComplete = action.payload;
        }
    }
});

export const { setSite, setBrandSearchComplete } = siteSlice.actions;
